<template>
    <div class="customization ">
        <div class="notaryServices_content_titles">服务咨询</div>
        <div class="notaryServices_gzzx">
            <div class="notaryServices_gzzximg">
                <div class="notaryServices_background1">
                    <el-image class = 'clImg' :src="require('../../assets/images/leftship.png')" fit="contain" />
                    <div class="notaryServices_background_text">欢迎</div>
                    <div class="notaryServices_background_text1">进行服务咨询</div>
                </div>
            </div>
            <div class="notaryServices_gzzxtext">
                <el-form ref="ruleFormRef" :model="ruleForm" :rules="rules" label-width="120px" class="demo-ruleForm"
                    :size="formSize" status-icon>
                    <el-row :gutter="24">


                        <el-col :span="12" :class="['wui-input-error-color-' + themeColor]">
                            <el-form-item label="咨询地区：" prop="zxdq1">
                                <el-cascader ref = 'addressCode'  size="large" style="height: 40px;width: 100%;" v-model="ruleForm.zxdq1" :options="treeList" @change="handleChange" :props='CascaderProps' />
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" :class="['wui-input-error-color-' + themeColor]">
                            <el-form-item label="咨询类型：" prop="zxlx">
                                <el-select :teleported="false" v-model="ruleForm.zxlx" filterable class="m-2"
                                    placeholder="请选择咨询类型" size="large" style="height: 40px;width: 100%;">
                                    <el-option v-for="item in tabsItem" :key="item._id" :label="item.zxlx"
                                        :value="item._id" />
                                </el-select>
                            </el-form-item>
                        </el-col>

                        <el-col :span="12" :class="['wui-input-error-color-' + themeColor]">
                            <el-form-item label="公司名称：" prop="gsmc">
                                <el-input v-model="ruleForm.gsmc" placeholder="请输入公司名称" style="height: 40px;" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" :class="['wui-input-error-color-' + themeColor]">
                            <el-form-item label="公司职务：" prop="gszw">
                                <el-input v-model="ruleForm.gszw" placeholder="请输入公司职务" style="height: 40px;" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" :class="['wui-input-error-color-' + themeColor]">
                            <el-form-item :label="'姓' + '　'.repeat(2) + '名：'" prop="xm">
                                <el-input v-model="ruleForm.xm" placeholder="请输入姓名" style="height: 40px;" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" :class="['wui-input-error-color-' + themeColor]">
                            <el-form-item label="手机号码：" prop="sjhm">
                                <el-input v-model="ruleForm.sjhm" placeholder="请输入联系手机号" style="height: 40px;" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="24" :class="['wui-input-error-color-' + themeColor]">
                            <el-form-item label="咨询内容：" prop="zxnr">
                                <el-input v-model="ruleForm.zxnr" :autosize="{ minRows: 7, maxRows: 7 }" type="textarea"
                                    placeholder="请输入想要咨询的外贸服务内容" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-form-item>
                        <div :class="['wui-background-color-' + themeColor]" class="btn"
                            @click="submitForm(ruleFormRef)">
                            立即提交咨询
                        </div>
                    </el-form-item>
                </el-form>
            </div>
        </div>

    </div>
</template>

<script>
import { getCurrentInstance, ref, watch, computed, onMounted, nextTick } from "vue";
import { useRoute, useRouter } from "vue-router";
export default {
    name: "secondPage",



    setup(props) {
        const { proxy } = getCurrentInstance();
        const router = useRouter();
        const route = useRoute();
        let articleData = ref({});
        const ruleFormRef = ref(null)
        const tabsItem = ref([])
        const addressCode = ref('')
        const CascaderProps = ref({ label: 'name', value: 'code', children: 'children' })
        const getTyleList = () => {   //法律类型接口
            proxy.$request({
                url: "QPSTZX_GJDLYSFW_ZXFLLIST",
                method: "post",
                data: {}
            }).then((res) => {
                if (res.data.code == "000") {
                    res.data.result.forEach((item, index) => {
                        if (index <= 3) {
                            tabsItem.value.push({
                                sort: index + 1,
                                ...item
                            })
                        } else {
                            if (index == 4) {
                                tabsItem.value.push({
                                    sort: 1,
                                    ...item
                                })
                            } else if (index == 5) {
                                tabsItem.value.push({
                                    sort: 2,
                                    ...item
                                })
                            } else if (index == 6) {
                                tabsItem.value.push({
                                    sort: 3,
                                    ...item
                                })
                            } else if (index == 7) {
                                tabsItem.value.push({
                                    sort: 4,
                                    ...item
                                })
                            }
                        }
                    });
                }
            }).catch((err) => {
                console.log(err);
            });
        }
        getTyleList()
        const treeList = ref([])
        const getlisttree = () => {
            proxy.$request({
                url: "B2B_W_AREA_FINDAREATREE",
                method: "post",
                data: {

                },
            }).then((res) => {
                if (res.data.code == '000') {
                treeList.value = res.data.result[0].children
                }
            }).catch((err) => {
                console.log(err)
            })
            }
            getlisttree()

            const handleChange = (value) => {
                console.log(value,222)
               console.log( addressCode.value.getCheckedNodes().lastItem.pathLabels)
               let arr = addressCode.value.getCheckedNodes().lastItem.pathLabels
               ruleForm.value.zxdq = arr[0]+'/'+arr[1]+'/'+arr[2]
                ruleForm.value.dqdm = value[2]
                // ruleForm.value.areaCity = value[1]
                // ruleForm.value.areaCou = value[2]
                }

        const ruleForm = ref({})
        const rules = ref({
            zxdq1:[
            { required: true, message: "请选择咨询地区", trigger: "blur" },
            ],
            xm: [
                { required: true, message: "请输入姓名", trigger: "blur" },

            ],
            sjhm: [
                { required: true, message: "请输入联系手机号", trigger: "blur" },

            ],
            zxlx: [
                { required: true, message: "请选择咨询类型", trigger: "change" }
            ],
            zxnr: [
                { required: true, message: "请输入咨询内容", trigger: "blur" },

            ],
        })
        const updateTheme = () => {
            document.documentElement.style.setProperty('--el-color-error', props.themeColor);
        }
        updateTheme()

        const submitForm = async (formEl) => {
            if (!formEl) return
            await formEl.validate((valid, fields) => {
                if (valid) {
                    addList()
                    console.log(ruleForm.value, '2222')
                } else {
                    console.log('error submit!', fields)
                }
            })
        }
        const addList = () => {   //保存数据
            proxy.$request({
                url: "FLZX_FLZXADD",
                method: "post",
                data: ruleForm.value
            }).then((res) => {
                if (res.data.code == "000") {
                    proxy.$message({
                        type: "success",
                        message: "提交成功"
                    });
                    ruleForm.value = {}
                    ruleFormRef.value.resetFields();
                }
            }).catch((err) => {
                console.log(err);
            });
        }
        const areaData = ref([]);
        const cxls = () => { //查询律所
            proxy.$request({
                url: "LSGL_LIST",
                data: {},
            })
                .then((res) => {
                    areaData.value = res.data.result
                })
                .catch((err) => {
                    console.log(err);
                });
        }

        const notaryServicesref = ref(null);
        const footerHeight = ref(0);
        onMounted(async () => {
            await nextTick();
            if (notaryServicesref.value) {
                footerHeight.value = notaryServicesref.value.offsetHeight
            }

            window.addEventListener('resize', () => {
                if (notaryServicesref.value) {
                    footerHeight.value = notaryServicesref.value.offsetHeight
                }
            });
        });
        cxls()
        return {
            articleData,
            notaryServicesref,
            ruleForm,
            ruleFormRef,
            areaData,
            rules,
            submitForm,
            getTyleList,
            tabsItem,
            getlisttree,
            treeList,
            handleChange,
            CascaderProps,
            addressCode
        };
    },
};
</script>


<style lang="less" >
.customization {
    width: 100%;
    height: 100%;
    background: #F9FAFC;
    box-sizing: border-box;
    padding-bottom: 50px;
    padding-top: 40px;

    .notaryServices_content_titles {
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-items: center;
        // margin-top: 50px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 30px;
        color: #313A4B;
        line-height: 42px;
    }

    .notaryServices_gzzx {
        box-sizing: border-box;
        display: flex;
        margin-top: 30px;

        .notaryServices_gzzximg {
            box-sizing: border-box;
            width: 386px;
            height: 444px;

            // border-top-left-radius:20px;
            // border-bottom-left-radius:20px;
            .notaryServices_background1 {
                border-top-left-radius: 20px;
                border-bottom-left-radius: 20px;
                box-sizing: border-box;
                width: 100%;
                height: 100%;
                background: url(../../assets/images/leftBj.png) no-repeat;
                background-size: 100% 100%;
                // font-weight: 600;
                font-size: 34px;
                color: #FFFFFF;
                padding-left: 46px;
                padding-top: 70px;
                .clImg{
                    width:103px;
                    height:109px;
                    margin-bottom:60px
                }
                .notaryServices_background_text {
                    font-size: 34px;
                }

                .notaryServices_background_text1 {
                    margin-top: 30px;
                    font-weight: 600;

                }
            }
        }

        .notaryServices_gzzxtext {
            box-sizing: border-box;
            flex: 1;
            background: #F9FAFC;
            padding: 28px 30px 0 30px;



        }

    }
    .el-cascader .el-input__wrapper{
        height:40px!important;
    }
}


.btn {
    width: 134px;
    height: 40px;
    background: #0754BD;
    font-size: 14px;
    color: #FFFFFF;
    line-height: 40px;
    text-align: center;
    cursor: pointer;
    border-radius: 20px;
}

:deep(.h40) {
    .el-input__inner {
        height: 40px!important;
    }

}
</style>